'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = require('lodash/fp');

var _lodash = require('lodash');

var _emptyObject = require('./emptyObject');

var _emptyObject2 = _interopRequireDefault(_emptyObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a new object that is the intersection of the keys object and source object.
 * The keys object is the object used for the keys, the source object is the object to use for the values.
 * Any key that exists on the keys object but not the source object will be defaulted to null.
 *
 * <pre>
 *     pickWithDefault({ a: '1', b: '2', c: '3' }, { a: '4', d: '5', e: '6' });
 *     // => { a: '4', b: null, c: null }
 * </pre>
 *
 * @param keysObject {Object} The object to use for keys.
 * @param source {Object} The object to use for values.
 */
exports.default = function (keysObject, source) {
  var pickKeys = (0, _lodash.keys)(keysObject);
  var pickedValues = (0, _fp.pick)(pickKeys, source);
  var defaultValues = (0, _emptyObject2.default)(keysObject);
  return (0, _lodash.defaults)(pickedValues, defaultValues);
};

// Util
// Lib


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/milanoteLodash/objectIntersection.js
// module id = 2130
// module chunks = 0